<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login d-flex flex-column flex-lg-row flex-row-fluid bg-white"
      id="kt_login"
    >
      <!--begin::Aside-->
      <div class="auth-aside d-flex flex-row-auto pb-1">
        <!--begin: Aside Container -->
        <div class="d-flex flex-row-fluid flex-column justify-content-between">
          <!--begin: Aside header -->
          <div class="text-right">
            <img
              src="/media/svg/soha/icons/login-wave-top.svg"
              style="width: 65%"
            />
          </div>
          <!--end: Aside header -->
          <!--begin: Aside content -->
          <div
            class="flex-column-fluid d-flex flex-column justify-content-center"
          >
            <div class="text-center">
              <img src="/media/logos/soha-logo.png" width="103" height="96" />
            </div>
            <h3 class="font-size-h1 mt-10 mb-5 text-white text-center">
              <span class="secondary-color">سها</span>؛
              <span class="secondary-color">سـ</span>امانه
              <span class="secondary-color">هـ</span>وشمند
              <span class="secondary-color">ا</span>ستخدام
            </h3>
            <h5 class="font-weight-lighter text-center text-white opacity-60">
              راهکار بهینه برای استخدام استعدادهای برتر
            </h5>
          </div>
          <!--end: Aside content -->

          <!--begin: Aside footer for desktop -->
          <div
            class="justify-content-center mt-15 bgi-no-repeat text-center"
            style="
              background: url('/media/svg/soha/icons/login-wave-bottom.svg');
              height: 40%;
            "
          >
            <a
              href="https://soha-ats.com/contact-us"
              class="font-weight-bold text-white text-center contact-vertical-center"
            >
              <span>
                <inline-svg src="/media/svg/soha/icons/call.svg" />
              </span>
              <span class="ml-2 auth-contact">تماس با ما</span>
            </a>
          </div>
          <!--          <div class="text-right">-->
          <!--            <img src="/media/svg/soha/icons/login-wave-bottom.svg" style="width: 100%"/>-->
          <!--          </div>-->
          <!--end: Aside footer for desktop -->
        </div>
        <!--end: Aside Container -->
      </div>
      <!--begin::Aside-->

      <!--begin::Content-->
      <div
        class="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden"
      >
        <div class="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
          <router-view></router-view>
        </div>
      </div>
      <!--end::Content-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "auth",
  methods: {},
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    backgroundImage() {
      return process.env.BASE_URL + "media/bg/bg-4.jpg";
    },
  },
};
</script>
